(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
function initNbDetails(root){
  root.querySelectorAll('[data-nb-details-carousel]').forEach(function(carousel){
    if(carousel.dataset.initialized)return;
    var track=carousel.querySelector('.feature-cards');
    if(!track)return;
    carousel.dataset.initialized='true';
    var prev=carousel.querySelector('[data-nb-details-direction="-1"]');
    var next=carousel.querySelector('[data-nb-details-direction="1"]');
    function update(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
    carousel.querySelectorAll('[data-nb-details-direction]').forEach(function(button){button.addEventListener('click',function(){
      var card=track.querySelector('.feature-card');
      var grid=track.querySelector('.feature-cards__grid');
      var step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(grid).gap)||0);
      track.scrollBy({left:Number(button.dataset.nbDetailsDirection)*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });});
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initNbDetails(document);
document.addEventListener('DOMContentLoaded',function(){initNbDetails(document)});
document.addEventListener('shopify:section:load',function(event){initNbDetails(event.target)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super()
		}

		hide() {
			super.hide()
			window.pauseAllMedia()
		}

		show(opener) {
			super.show(opener)
			this.showActiveMedia()
		}

		showActiveMedia() {
			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			)

			if (
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMedia
					.querySelector('template')
					?.content?.querySelector('.js-youtube')
			) {
				activeMedia.loadContent()
			}
		}
	}

	customElements.define('product-modal', ProductModal)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-apparel-size-guide"] && !Shopify.designMode) return;
  try {
    
  function moveNobadaySizeGuide(){
    var section=document.querySelector('[data-nb-size-guide-section]');
    var picker=document.querySelector('.product-section variant-radios, .product-section variant-selects');
    if(!section||!picker)return;
    var sizeField=Array.from(picker.querySelectorAll('fieldset')).find(function(field){var label=field.querySelector('legend');return label&&/^(size|尺码|尺寸)$/i.test(label.textContent.trim())});
    var group=sizeField&&sizeField.querySelector('.product-form__group-wrapper');
    if(group){
      group.classList.add('nb-size-picker-layout');
      var options=group.querySelector('.product-form__controls-group');
      if(section.parentNode!==group)group.insertBefore(section,options);
    }else if(picker.parentNode&&picker.nextElementSibling!==section){
      picker.parentNode.insertBefore(section,picker.nextElementSibling);
    }
  }
  function convertNobadayRange(text,factor,suffix){return text.replace(/(\d+(?:\.\d+)?)/g,function(value){return Math.round(parseFloat(value)*factor).toString()}).replace(/\s*(cm|kg|in|lb)\b/gi,'').trim()+' '+suffix}
  function nobadayRecommendationHeightFirst(table){var cell=table&&table.querySelector('thead th:first-child');var label=cell?cell.textContent.toLowerCase():'';return label.indexOf('height')!==-1&&label.indexOf('height')<label.indexOf('weight')}
  function convertNobadayRecommendationCell(cell,type,unit){if(!cell.dataset.raw)cell.dataset.raw=cell.textContent.trim();cell.textContent=unit==='cm'?cell.dataset.raw:convertNobadayRange(cell.dataset.raw,type==='height'?1/2.54:2.20462,type==='height'?'in':'lb')}
  function setNobadayUnit(section,unit){if(!section)return;section.querySelectorAll('[data-nb-measure]').forEach(function(cell){if(!cell.dataset.cm)cell.dataset.cm=cell.textContent.trim();var original=cell.dataset.cm;if(unit==='cm'){cell.textContent=original;return}cell.textContent=original.replace(/(\d+(?:\.\d+)?)/g,function(value){return(Math.round((parseFloat(value)/2.54)*10)/10).toString()}).replace(/\s*cm\b/gi,' in');if(!/in\b/i.test(cell.textContent))cell.textContent+=' in'});section.querySelectorAll('[data-nb-height-range]').forEach(function(cell){var table=cell.closest('.nb-size-guide-modal__table--recommend');convertNobadayRecommendationCell(cell,nobadayRecommendationHeightFirst(table)?'weight':'height',unit)});section.querySelectorAll('[data-nb-weight-range]').forEach(function(cell){var table=cell.closest('.nb-size-guide-modal__table--recommend');convertNobadayRecommendationCell(cell,nobadayRecommendationHeightFirst(table)?'height':'weight',unit)});section.querySelectorAll('[data-nb-size-unit]').forEach(function(button){button.classList.toggle('is-active',button.dataset.nbSizeUnit===unit)})}
  function closeNobadaySizeGuide(section){var modal=section&&section.querySelector('.nb-size-guide-modal');if(modal){modal.hidden=true;document.body.style.overflow=''}}
  document.addEventListener('click',function(event){var unit=event.target.closest('[data-nb-size-unit]');if(unit){setNobadayUnit(unit.closest('[data-nb-size-guide-section], [data-nb-fit-guide]'),unit.dataset.nbSizeUnit);return}var trigger=event.target.closest('.nb-size-guide__trigger');if(trigger){var section=trigger.closest('[data-nb-size-guide-section]');var modal=section.querySelector('.nb-size-guide-modal');modal.hidden=false;document.body.style.overflow='hidden';setNobadayUnit(section,'cm');section.querySelector('.nb-size-guide-modal__panel').focus();return}var close=event.target.closest('[data-nb-size-guide-close]');if(close)closeNobadaySizeGuide(close.closest('[data-nb-size-guide-section]'))})
  document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('[data-nb-size-guide-section]').forEach(closeNobadaySizeGuide)})
  document.addEventListener('DOMContentLoaded',moveNobadaySizeGuide);document.addEventListener('shopify:section:load',moveNobadaySizeGuide);setTimeout(moveNobadaySizeGuide,800)

  } catch(e) { console.error(e); }
})();
})();
